// extracted by mini-css-extract-plugin
export var cardHeader = "_fn-0";
export var reorderHandle = "_fn-3";
export var titleArea = "_fn-1";
export var titleAreaWithHandle = "_fn-2";